<template>
  <div class="col col-12" style="height:100%; width:100%;">
    <div class="h-100 d-flex flex-column" id="percentiles-chart-div">
      <div class="row f-row mt-1">
        <div class="col col-1"></div>
        <div class="col col-10">
          <table
            class="table table-sm table-responsive table-borderless table-market-legend"
            style="width: 100%; background: rgba(0,0,0,0)"
          >
            <tbody>
              <tr>
                <td class="text-left" style="width:10%;">
                  Short Term:
                </td>
                <td class="text-left trend-info" style="width:10%;">
                  <span
                    v-bind:class="[
                      shortTrend === 'UP'
                        ? 'uptrend'
                        : shortTrend === 'DOWN'
                        ? 'downtrendRed'
                        : ''
                    ]"
                  >
                    <i
                      class="fa fa-long-arrow-up"
                      v-if="shortTrend === 'UP'"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      v-else-if="shortTrend === 'DOWN'"
                    ></i>
                  </span>
                  {{ shortTrend }}TREND
                </td>
              </tr>
              <tr>
                <td class="text-left" style="width:10%;">
                  Medium Term:
                </td>
                <td class="text-left trend-info" style="width:10%;">
                  <span
                    v-bind:class="[
                      mediumTrend === 'UP'
                        ? 'uptrend'
                        : mediumTrend === 'DOWN'
                        ? 'downtrendRed'
                        : ''
                    ]"
                  >
                    <i
                      class="fa fa-long-arrow-up"
                      v-if="mediumTrend === 'UP'"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      v-else-if="mediumTrend === 'DOWN'"
                    ></i>
                  </span>
                  {{ mediumTrend }}TREND
                </td>
              </tr>
              <tr>
                <td class="text-left" style="width:10%;">
                  Long Term:
                </td>
                <td class="text-left trend-info" style="width:10%;">
                  <span
                    v-bind:class="[
                      longTrend === 'UP'
                        ? 'uptrend'
                        : longTrend === 'DOWN'
                        ? 'downtrendRed'
                        : ''
                    ]"
                  >
                    <i
                      class="fa fa-long-arrow-up"
                      v-if="longTrend === 'UP'"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      v-else-if="longTrend === 'DOWN'"
                    ></i>
                  </span>
                  {{ longTrend }}TREND
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row f-row">
        <div class="col col-12 markets-chart-title">
          {{
            pickedTimeFrame.charAt(0).toUpperCase() +
              pickedTimeFrame.slice(1).toLowerCase()
          }}-Term Trend Analysis
        </div>
      </div>
      <div class="row f-row text-right">
        <div class="col col-12" style="height: 20px;">
          <span
            style="color: var(--textinactive);padding-right: 8px !important;font-size: 0.8rem;"
          >
            {{ trendsAnalyzed }} trends analyzed
          </span>
        </div>
      </div>

      <div class="row f-row">
        <div
          class="col col-12 trend-analysis-div"
          v-bind:class="[
            radioSelection === 1 ? 'program-bgnd-light' : 'program-bgnd-dark'
          ]"
        >
          <div class="row f-row text-left">
            <div class="col col-12">
              <input
                type="radio"
                id="return"
                value="1"
                v-model="radioSelection"
                @click="onClickAnalysis"
              />
              <label for="return">
                <span style="padding-left: 8px; font-size: 0.8rem;">
                  Trend Percentage Change (Log Scale)
                </span>
              </label>
            </div>
          </div>
          <div class="row f-row text-left">
            <div class="col col-12">
              <table
                class="table table-sm table-borderless table-market-legend"
                style="width: 100%; background: rgba(0,0,0,0)"
              >
                <tbody>
                  <tr>
                    <td class="text-left" style="width:50%;">
                      <span class="inline-ul ml-1">Ave. Return:</span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="uptrend"
                          ><i class="fa fa-long-arrow-up"></i
                        ></span>
                        {{ changeUp | percentageFormat }}
                      </span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="downtrendRed"
                          ><i class="fa fa-long-arrow-down"></i
                        ></span>
                        {{ changeDn | percentageFormat }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left" style="width:50%;">
                      <span class="inline-ul ml-1">90% Percentile:</span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="uptrend"
                          ><i class="fa fa-long-arrow-up"></i
                        ></span>
                        {{ changeUp90 | percentageFormat }}
                      </span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="downtrendRed"
                          ><i class="fa fa-long-arrow-down"></i
                        ></span>
                        {{ changeDn90 | percentageFormat }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row f-row">
        <div
          class="col col-12 trend-analysis-div"
          v-bind:class="[
            radioSelection === 0 ? 'program-bgnd-light' : 'program-bgnd-dark'
          ]"
        >
          <div class="row f-row text-left">
            <div class="col col-12">
              <input
                type="radio"
                id="length"
                value="0"
                v-model="radioSelection"
                @click="onClickAnalysis"
              />
              <label for="length">
                <span style="padding-left: 8px; font-size: 0.8rem;">
                  Trend Length in Months
                </span>
              </label>
            </div>
          </div>
          <div class="row f-row text-left">
            <div class="col col-12">
              <table
                class="table table-sm table-borderless table-market-legend"
                style="width: 100%; background: rgba(0,0,0,0)"
              >
                <tbody>
                  <tr>
                    <td class="text-left" style="width:50%;">
                      <span class="inline-ul ml-1">Ave. Length:</span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="uptrend"
                          ><i class="fa fa-long-arrow-up"></i
                        ></span>
                        {{ lengthUp }} M
                      </span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="downtrendRed"
                          ><i class="fa fa-long-arrow-down"></i
                        ></span>
                        {{ lengthDn }} M
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left" style="width:50%;">
                      <span class="inline-ul ml-1">90% Percentile:</span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="uptrend"
                          ><i class="fa fa-long-arrow-up"></i
                        ></span>
                        {{ lengthUp90 }} M
                      </span>
                    </td>
                    <td class="text-left" style="width:25%;">
                      <span class="trend-info">
                        <span class="downtrendRed"
                          ><i class="fa fa-long-arrow-down"></i
                        ></span>
                        {{ lengthDn90 }} M
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!--CHART TITLE-->
      <div class="row f-row">
        <div class="col col-12 markets-chart-title mt-1">
          Trends Comparison: Kernel Density Analysis
        </div>
      </div>
      <!--LEGEND-->
      <!-- Row: legend -->
      <div class="row f-row">
        <div class="col col-12 text-center" style="height: 20px;">
          <table
            class="table table-sm table-responsive table-borderless table-market-legend"
            style="width: 100%; background: rgba(0,0,0,0)"
          >
            <tbody>
              <tr>
                <td class="text-center" style="width:10%;">
                  <i
                    class="fa fa-minus fa-rotate-90"
                    style="color: var(--expo)"
                  ></i>
                  <span class="inline-ul ml-1">Up-trend {{ legendText }}</span>
                </td>
                <td class="text-center" style="width:10%;">
                  <i
                    class="fa fa-minus fa-rotate-90"
                    style="color: var(--graylightbackground)"
                  ></i>
                  <span class="inline-ul ml-1"
                    >Down-trend {{ legendText }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--CHART-->
      <div
        class="h-100 d-flex flex-column"
        id="trend_selected-div"
        style="width: 100%;"
      >
        <svg id="svg-trend_selected"></svg>
      </div>
    </div>
  </div>
</template>

<script>
import { D3Chart } from "@/_core/charts/D3Chart";
import { kernelDensityFunction } from "@/_core/_helpers/_kernel_density";
import {
  currencyFormat,
  formatPercentSm
} from "@/_core/_helpers/_parametric_tools";
import { area, axisBottom, format, max, scaleLinear, select } from "d3";

export default {
  name: "TrendsTable",
  props: {
    changeDn: { required: true },
    changeDn90: { required: true },
    changeUp: { required: true },
    changeUp90: { required: true },
    colorExpo: { required: true },
    colorDarkRed: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    dnCount: { required: true },
    dnRets: { required: true },
    lengthDn: { required: true },
    lengthDn90: { required: true },
    lengthUp: { required: true },
    lengthUp90: { required: true },
    longTrend: { required: true },
    mediumTrend: { required: true },
    pickedTimeFrame: { required: true },
    renderAuxChart: { required: true },
    shortTrend: { required: true },
    trendsAnalyzed: { required: true },
    upCount: { required: true },
    upRets: { required: true }
  },
  data() {
    return {
      currencyFormat: currencyFormat,
      D3Chart: null,
      dnChart: [],
      formatPercent: formatPercentSm,
      kernelDensityDown: [],
      kernelDensityUp: [],
      legendText: "Change",
      radioSelection: 1,
      upChart: []
    };
  },
  created() {
    this.D3Chart = new D3Chart("trend_selected-div", "svg-trend_selected");
  },
  filters: {
    percentageFormat: function(val) {
      return format(",.1%")(val);
    }
  },
  watch: {
    colorTheme() {
      this.createChart();
    },
    renderAuxChart() {
      this.createChart();
    }
  },
  methods: {
    onClickAnalysis() {
      this.radioSelection = 1 - this.radioSelection;
      this.legendText = this.radioSelection === 1 ? "Change" : "Length";
      this.createChart();
    },
    createChart() {
      let vis = this;
      select("#trend_selected-div")
        .select("svg > *")
        .remove();
      let xMax, yMin, yMax;
      if (this.radioSelection === 0) {
        this.upChart = this.upCount;
        this.dnChart = this.dnCount;
      } else {
        this.upChart = this.upRets;
        this.dnChart = this.dnRets.map(d => -d);
      }
      xMax =
        1.1 *
        Math.max(
          max(this.upChart, d => d),
          max(this.dnChart, d => d)
        );
      this.kernelDensityUp = kernelDensityFunction(this.upChart, 0, xMax);
      this.kernelDensityDown = kernelDensityFunction(this.dnChart, 0, xMax);

      yMin = -max(this.kernelDensityDown, d => d.y);
      yMax = max(this.kernelDensityUp, d => d.y);
      let barHeight = (yMax - yMin) * 0.05;
      let barWidth = xMax * 0.0015;

      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.5,
        8,
        0.5,
        15,
        0.5,
        25,
        0.5,
        15,
        this.colorTheme
      );

      // === set y axis
      this.svgNode.y = scaleLinear()
        .range([this.svgNode.height, 0])
        .domain([yMin, yMax]);

      // === set x axis
      this.svgNode.x = scaleLinear()
        .range([0, this.svgNode.width])
        .domain([0, xMax]);
      // add the x gridlines
      if (this.radioSelection === 1) {
        this.svgNode
          .append("g")
          .attr("class", "axis--y-fund")
          .attr("transform", "translate(0," + vis.svgNode.height + ")")
          .call(
            axisBottom(this.svgNode.x)
              .ticks(6)
              .tickFormat(this.formatPercent)
              .tickSize(-this.svgNode.height)
          );
      } else {
        this.svgNode
          .append("g")
          .attr("class", "axis--y-fund")
          .attr("transform", "translate(0," + vis.svgNode.height + ")")
          .call(
            axisBottom(this.svgNode.x)
              .ticks(6)
              .tickSize(-this.svgNode.height)
          );
        // x axis label
        this.svgNode
          .append("g")
          .append("text")
          .attr("y", 0)
          .attr("dy", ".71em")
          .attr("class", "axis-label")
          .attr(
            "transform",
            `translate(${vis.svgNode.width}, ${vis.svgNode.height -
              vis.svgNode.margin.top})`
          )
          .style("text-anchor", "end")
          .style("dominant-baseline", "ideographic")
          .text("Months");
      }

      this.svgNode.xAxis = axisBottom(this.svgNode.x)
        .ticks(6)
        .tickSize(0)
        .tickFormat("");

      // add positive kernel density
      this.svgNode
        .append("path")
        .datum(this.kernelDensityUp)
        .attr("class", "kernelStyleUp") // .attr("fill", "url(#gradientCommodityKer)")
        .attr(
          "d",
          area()
            .x(function(d) {
              return vis.svgNode.x(d.x);
            })
            .y0(this.svgNode.y(0))
            .y1(function(d) {
              return vis.svgNode.y(d.y);
            })
        );

      // add negative kernel density
      this.svgNode
        .append("path")
        .datum(this.kernelDensityDown)
        .attr("class", "kernelStyleDown") // .attr("fill", "url(#gradientCommodityKer)")
        .attr(
          "d",
          area()
            .x(function(d) {
              return vis.svgNode.x(d.x);
            })
            .y0(this.svgNode.y(0))
            .y1(function(d) {
              return vis.svgNode.y(-d.y);
            })
        );

      this.bars(
        "TREND2a",
        this.upChart,
        this.svgNode,
        false,
        this.colorExpo,
        this.colorExpo,
        true,
        barWidth,
        barHeight
      );
      this.bars(
        "TREND2b",
        this.dnChart.map(d => d),
        this.svgNode,
        false,
        this.colorDarkRed,
        this.colorDarkRed,
        true,
        barWidth,
        -barHeight
      );

      this.svgNode
        .append("g")
        .attr("transform", "translate(0," + this.svgNode.y(0) + ")")
        .call(this.svgNode.xAxis);
    },
    bars(
      name,
      data,
      svg,
      multipleColor,
      fillColor,
      color,
      toZero,
      barWidth,
      barHeight
    ) {
      var balbar = svg
        .selectAll(".bars" + name)
        .data([data])
        .enter()
        .append("g")
        .attr("class", "bars" + name);
      balbar
        .selectAll("rect")
        .data(function(d) {
          return d;
        })
        .enter()
        .append("rect")
        .style("fill", function(d, i) {
          return multipleColor ? fillColor[i] : fillColor;
        })
        .style("stroke", function(d, i) {
          return multipleColor ? color[i] : color;
        })
        .style("stroke-width", 1)
        .attr("x", function(d) {
          return svg.x(d) - svg.x(barWidth / 2);
        })
        .attr("y", function() {
          return Math.min(svg.y(0), svg.y(barHeight));
        })
        .attr("class", function(d, i) {
          return "bar" + name + "" + i;
        })
        .attr("height", function() {
          return toZero === true ? Math.abs(svg.y(0) - svg.y(barHeight)) : 2;
        })
        .attr("width", svg.x(barWidth));
    }
  }
};
</script>
